import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { IconSizesEnum, IIcon } from '../icon/icon.component';

@Component({
  selector: 'i2g-checkmark',
  templateUrl: './checkmark.component.html',
  styleUrls: ['./checkmark.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckmarkComponent implements OnInit {
  @Input() iconSize: IconSizesEnum = IconSizesEnum.small;

  checkmarkIcon: IIcon;

  constructor() {}

  ngOnInit() {
    this.checkmarkIcon = {
      name: 'checkmark',
      size: this.iconSize,
    };
  }
}
